export default "__VITE_ASSET__CIxUrtMZ__"